export default __webpack_public_path__ + "static/media/_dkg_darm_rgb.b9d6a687.svg";